import React, { useEffect, useState } from "react";
import GreyInfo from "../greyInfo/greyInfo.js";
import RadioButtonOptions from "../RadioButtonOptions/RadioButtonOptions.js";
export default function ChooserComponent(props) {
    const { component } = props;
    const [state, setState] = useState();
    useEffect(() => {
        props.onChange({
            [component.id]: {
                inputName: component.fieldName,
                value: state,
            },
        });
    }, [state]);
    return (React.createElement("div", { id: component.id, className: props.isOutlined ? "flow-component-outlined" : "" },
        React.createElement(RadioButtonOptions, { state: state, onChange: setState, label: component.label, options: component.options.map((option) => ({
                value: option.name,
                label: (React.createElement("span", null,
                    option.label,
                    option.price > 0 && React.createElement(GreyInfo, null,
                        " +",
                        option.price,
                        "z\u0142"))),
            })), style: "high-pr", alignment: component.direction, preIndex: component.id })));
}
